export default
{
    "blogItems": [
        {
            "title": "SEO Quis Vestibulum",
            "date": "14.07.2017",
            "category": "Development",
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,",
            "imgPath": "./img/Scrabble.jpg"
        },
        {
            "title": "SEO Quis Vestibulum",
            "date": "14.07.2017",
            "category": "Development",
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,",
            "imgPath": "./img/Keyboard.jpg"
        },
        {
            "title": "SEO Quis Vestibulum",
            "date": "14.07.2017",
            "category": "Development",
            "description": "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,",
            "imgPath": "./img/Keyboard-2.jpg"
        }
    ]
}